module.exports = __webpack_public_path__ + "img/simon_zsuzsanna_reszketes_3.2600879a.jpg";